import { REGIONS } from "@/lib/services";

function Row({ hidden = false }) {
    return (
        <div aria-hidden={hidden} className="flex shrink-0 items-center">
            {REGIONS.map((item, i) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-xl font-bold uppercase tracking-tight text-slate-300 md:text-2xl">
                        {item}
                    </span>
                    <svg width="12" height="12" viewBox="0 0 14 14" aria-hidden="true">
                        <path d="M7 0c1 4 3 6 7 7-4 1-6 3-7 7-1-4-3-6-7-7 4-1 6-3 7-7z" fill={i % 2 ? "#C5A059" : "#64748B"} />
                    </svg>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div data-testid="regions-marquee" className="marquee overflow-hidden border-y border-gold/20 bg-ink-2 py-6">
            <div className="marquee-track">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}